import {
    computed,
} from 'vue';
import { IHotelOfferTariff } from '@ve/components/hotel/hotelOffersTariffsPopup/common/types';

export default (props: {
    tariff: IHotelOfferTariff,
    selectedTariff: IHotelOfferTariff,
}) => {
    const isSelected = computed(() => props.tariff === props.selectedTariff);

    return {
        isSelected,
    };
};